import * as React from 'react'
import './Coupon.css'
import { Redirect } from 'react-router-dom';

export default function Redirected() {
  return <Redirect to="/not-found"/>
}